module.exports = __webpack_public_path__ + "img/barcelona.124393ed.png";